import { useMutation } from "react-query";
import { createConnectionOauthStateApi } from "../apis/oauth";

export const useCreateConnectionOauthState = () => {
    const mutation = useMutation(
        (payload: {
            secretId: string;
            formData: Record<string, unknown>;
            connectionOauthDefinitionId: number;
            requestId: number;
            linkHeaders?: Record<string, unknown>;
        }) => createConnectionOauthStateApi(payload)
    );

    return {
        createConnectionOauthState: mutation.mutateAsync,
        isLoading: mutation.isLoading,
    };

};